import {
    StyledIconInformation,
    StyledResultsFoundMessage,
    StyledRetailerResultsFoundMessage,
    StyledSearchCountAndAdsDisclaimerContainer,
} from '../../patterns/search-facets/search-facets.styles'
import { Tooltip } from '../tooltip/tooltip'
import React, { useRef } from 'react'
import { numberOfResultsFoundValue } from '../../utils/search/search-results-util/search-results.util'

export interface SearchCountAndAdsDisclaimerContainerProps {
    totalResults: number
    sortDescription: string
    position?: 'centre' | 'left' | 'right'
    isRetailerStock?: boolean
}

export const SearchCountAndAdsDisclaimerContainer = ({
    totalResults,
    sortDescription,
    position = 'centre',
    isRetailerStock = false,
}: SearchCountAndAdsDisclaimerContainerProps) => {
    const [value, suffix] = numberOfResultsFoundValue(totalResults)
    const ref = useRef<HTMLDivElement>(null)

    return (
        <StyledSearchCountAndAdsDisclaimerContainer>
            {!isRetailerStock ? (
                <>
                    <StyledResultsFoundMessage data-testid="search-result-count" ref={ref}>
                        {value}
                        {suffix}
                    </StyledResultsFoundMessage>
                    <Tooltip
                        message={sortDescription}
                        position={position}
                        width={ref.current?.scrollWidth.toString() || ''}
                    >
                        <StyledIconInformation title="" size={18} />
                    </Tooltip>
                </>
            ) : (
                <StyledRetailerResultsFoundMessage data-testid="search-result-count" ref={ref}>
                    <b>{value}</b>
                    {suffix}
                </StyledRetailerResultsFoundMessage>
            )}
        </StyledSearchCountAndAdsDisclaimerContainer>
    )
}
